import Navbar from "../Navbar";
import { Outlet, useNavigate } from "react-router";
import { useEffect } from "react";
import Footer from "../Footer/Footer";
import { Box } from "@mui/material";

const Layout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [navigate]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#FBFBFB",
        minHeight: "100vh",
      }}
    >
      <Navbar />
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          rowGap: { xs: 0, md: 2 },
        }}
      >
        <Outlet />
      </Box>

      <Footer />
    </div>
  );
};

export default Layout;
